<template>
  <div class="app-container">
    <!-- <div style="font-size: 24px; text-align: center">中转仓费用</div> -->
    <div
      style="
        height: 20px;
        width: 100px;
        font-size: 18px;
        margin-left: 30px;
        padding-left: 13px;
        background-color: white;
        z-index: 1000;
        position: relative;
      "
    >
      费用说明
    </div>
    <div class="fysm">
      1.快递费（各仓快递费用价格，查看下边表格明细）<br />
      2.操作费+0.29/元/单<br />
      3.拆包费+0.3/元/单（1仓、2仓可以自定义选择是否抵包 3仓强制抵包收费）<br />
      4.礼品费（仅提前出单并揽收，并且超时未到合真实发货，才会发小礼品，按各仓库的收货地首重收费，减少礼品费方案:1.买家付款后及时采购 2.采购时优先选择当日发货上家 3,根据上家发货地选择最近仓库中转） <br />
    </div>
    <br />
    <!-- <div
      style="
        height: 20px;
        width: 120px;
        font-size: 18px;
        margin-left: 30px;
        padding-left: 13px;
        background-color: white;
        z-index: 1000;
        position: relative;
      "
    >
      中转仓说明
    </div>
    <div class="fysm" style="font-size: 14px; color: red; height: auto;">
      前置仓：根据上家发货地，最近仓库中转。常用仓库中转模式。提前揽收1-4道物流虚拟轨迹，因淘宝平台管控可能偶尔发生无法提前揽收，不包赔付，如有发现可手动换礼品单过度解决。（小包裹推荐）
      <br />末端仓：根据买家收货地，最近仓库中转。随机发礼品包到中转仓库，上家包裹到达仓库后和礼品，合并包裹转出。真实物流轨迹，揽收超时包赔付。（全部包裹适用，大货，偏远地区，价格优惠优先推荐使用）
    </div> 
    <br />
    -->

    <!-- <span
        style="
          border-bottom: 2px solid #2cafe7;
          font-size: 16px;
          color: black;
          padding-bottom: 4px;
          padding-left: 10px;
          padding-right: 10px;
        "
        >在线充值</span
      > -->
      <div style = "display: flex; justify-content: space-between; width: 100%;">
      <span style="
          font-size: 14px;
          color: black;
          padding-bottom: 4px;
          margin-bottom: 10px;
          cursor: pointer;
        " v-for="(item, index) in ckNamelist" :key="index" 
         @click="addClass(item.id)" :class="{ spanColors: orderType ? item.id === orderType : index === 0 }">{{ item.name }}</span>
      <!-- <hr color="#dcdfe6" width="94%" /> -->
      </div>
      <div style="text-align: left">
      <div class="filter-container" style="margin-bottom: 10px">
        <el-table
          v-loading="priceListLoading"
          :data="priceList"
          highlight-current-row
          style="color: rgb(70, 70, 70)"
          :row-style="{ height: '0' }"
          :cell-style="{ padding: '3px 0' }"
          :header-cell-style="{
            background: 'rgb(247 248 252) !important',
            color: '#ededed  !important',
            padding: '7px 0',
            color: 'rgb(140, 140, 140)',
          }"
        >
          <el-table-column label="始发地" align="left" min-width="1">
            <template slot-scope="{ row }">
              <span>{{ row.warehouse }}</span>
            </template>
          </el-table-column>
          <el-table-column label="到达地" min-width="1" align="left">
            <template slot-scope="{ row }">
              <span>{{ row.province }}</span>
            </template>
          </el-table-column>
          <!-- 动态根据 price 对象的 key 生成列 -->
          <el-table-column
            v-for="(key, kidx) in priceKeys"
            :key="kidx"
            :label="formatKeyLabel(key)"
            min-width="1"
            align="left"
          >
            <template slot-scope="{ row }">
              <span>{{ getPriceByKey(row.price, key) }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import axios from "axios";

export default {
  name: "prices",
  data() {
    return {
      activeIndex: 0,
      idx: 2,
      isShow: false,
      nbisShow: false,
      userName: "",
      user_balance: 0.0,
      userType: "",

      userToken: Cookies.get("view_userToken"),
      isLogin: true,
      // cnyc_czjt_img: require("@/assets/cnyc_czjt.png"),
      // ry_czjt_img: require("@/assets/ry_czjt.jpg"),
      bjc_img: require("@/assets/zzc_bjc.png"),
      sjec_img: require("@/assets/zzc_sjec.png"),
      whc_img: require("@/assets/zzc_whc.png"),
      zjec_img: require("@/assets/zzc_zjec.png"),
      edc_img: require("@/assets/zzc_edc.png"),
      ckNamelist: [],
      listQuery: {
        page: 1,
        perPage: 10000,
      },
      orderType: 0,
      priceList: [],
      priceListLoading: false,
      provinceIds: [],
            // priceQuery: {
      //   site_id: "",
      //   warehouse_id: "",
      //   province_id: "",
      //   price_type: "",
      //   user_level_id: "",
      // },
    };
  },
  created() {
    this.getList();
    this.getProvince();
    this.getPriceList(1);
    //判断 登录userToken是否有效 userToken == '' ||
    // const userToken = Cookies.get("view_userToken");
    // if (userToken == undefined) {
    //     this.isLogin = false;
    //   this.$confirm("请先登录再使用！", "提示", {
    //     confirmButtonText: "确定",
    //   })
    //     .then(() => {
    //       // 重新导航到登录页面
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/login" });
    //     })
    //     .catch(() => {
    //       // 重新导航到首页
    //       localStorage.clear();
    //       this.$root.removeCookies();
    //       this.$router.push({ path: "/" });
    //     });
    //   return;
    // } else {
    //   this.isLogin = true;
    // }
  },
  methods: {
    getList() {
      const userToken = Cookies.get("view_userToken");
      if (userToken == undefined) {
        // 重新导航到登录页面
        alert("请先登录再使用！");
        localStorage.clear();
        Cookies.remove("view_userToken");
        Cookies.remove("view_userType");
        this.$router.push({ path: "/" });
        return;
      }

      this.ckNamelist = [];
      const url = this.$root.commonPreUrl + "/admin/warehouses/list";
      const token = Cookies.get("view_userToken");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: this.listQuery,
      });
      res
        .then((response) => {
          if (response.status == 200) {
            this.ckNamelist = response.data.data;
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
      // Just to simulate the time of the request
      setTimeout(() => {
        this.listLoading = false;
      }, 1.5 * 1000);
    },
    // handlePrices(wid) {
    //   this.priceListLoading = true;
    //   const site_id = Cookies.get("view_system_id");
    //   this.priceList = [];
    //   const url = this.$root.commonPreUrl + "/admin/prices";
    //   const token = Cookies.get("view_userToken");

    //   const res = axios.get(url, {
    //     headers: {
    //       Authorization: "Bearer " + token,
    //     },
    //     params: { site_id: site_id, warehouse_id: wid },
    //   });
    //   res
    //     .then((response) => {
    //       const resd = response.data;
    //       if (resd.code == 200) {
    //         const price1 = resd.data;
    //         let allPriceDatas = [];

    //         this.provinceIds.forEach((item) => {
    //           const prices_detail = price1[item];

    //           if (prices_detail != undefined) {
    //             let priceData = {
    //               provinceId: "",
    //               provinceName: "",
    //               cost: "",
    //               member: "",
    //               retail: "",
    //               agent: "",
    //             };
    //             priceData.provinceId = item;
    //             priceData.provinceName = this.allProvinces[item].name;
    //             priceData.retail = prices_detail.retail;
    //             allPriceDatas.push(priceData);
    //           }
    //         });
    //         this.priceList = allPriceDatas;
    //         this.priceListLoading = false;
    //       }

    //       setTimeout(() => {
    //         return;
    //       }, 5 * 1000);
    //     })
    //     .catch((error) => {
    //       console.error("初始请求失败:", error);
    //       // 处理错误，比如设置data为默认值或错误状态
    //       return;
    //     });
    //   // Just to simulate the time of the request
    //   setTimeout(() => {
    //     this.priceListLoading = false;
    //   }, 5 * 1000);
    // },
    getPriceList(wid) {
      this.priceListLoading = true;
      const site_id = Cookies.get("view_system_id");
      this.priceList = [];
      const url = this.$root.commonPreUrl + "/admin/prices/list1";
      const token = Cookies.get("view_userToken");

      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
        params: { site_id: site_id, warehouse_id: wid },
      });
      res.then((response) => {
          const resd = response.data;
          if (resd.code == 200) {
            this.priceList = resd.data;
            this.priceListLoading = false;
          }
          setTimeout(() => {
            return;
          }, 5 * 1000);
          return;
        })
    },
    // 获取所有省份
    getProvince() {
      const url = this.$root.commonPreUrl + "/admin/getProvince";
      const token = Cookies.get("view_userToken");
      const res = axios.get(url, {
        headers: {
          Authorization: "Bearer " + token,
        },
      });
      res
        .then((response) => {
          if (response.status == 200) {
            const pros = response.data.data;
            this.allProvinces = pros;
            this.provinceIds = Object.keys(pros);
            // const vueArray1 = Object.keys(pros).map((key) => pros[key]);
          }
          setTimeout(() => {
            return;
          }, 1.5 * 1000);
        })
        .catch((error) => {
          console.error("初始请求失败:", error);
          // 处理错误，比如设置data为默认值或错误状态
          return;
        });
    },
    addClass: function (OrderType) {
      this.orderType = OrderType;
      // this.handlePrices(OrderType);
      this.getPriceList(OrderType);
    //  this.listQuery.OrderType = OrderType;
     // this.handleFilter();
    },
 
    getPriceByKey(priceObj, key) {
      if (!priceObj) return "";
      return priceObj[key] !== undefined ? priceObj[key] : "";
    },

    formatKeyLabel(key) {
      if (/^\d+(?:\.\d+)?$/.test(key)) {
        return key + "KG";
      }
      return key;
    },
  },
  computed: {
    priceKeys() {
      if (!this.priceList || this.priceList.length === 0) return [];
      const first = this.priceList.find((r) => r && r.price && Object.keys(r.price).length > 0);
      if (!first) return [];
      const keys = Object.keys(first.price || {});
      const numeric = [];
      const others = [];
      keys.forEach((k) => {
        if (/^\d+(?:\.\d+)?$/.test(k)) numeric.push(k);
        else others.push(k);
      });
      numeric.sort((a, b) => parseFloat(a) - parseFloat(b));
      return numeric.concat(others);
    },
  },
};
</script>

<style scoped>
.app-container {
  text-align: left;
  font-size: 18px;
  font-weight: bold;
}
.czjt_img_cs {
  width: 80vw;
}
.fysm {
  /* width: 80vw; */
  /* height: 120px; */
  border: #dcdfe6 1px solid;
  padding: 18px 15px;
  text-align: left;
  margin-top: -8px;
  font-size: 15px;
}
.orderType {
  font-size: 16px;
  border-bottom: rgb(221, 221, 221) solid 1px;
  text-align: left;
  margin-bottom: 10px;
  height: 32px;
}
.orderType span {
  margin-left: 0px;
  margin-right: 0px;
  margin-bottom: 10px;
  cursor: pointer;
  padding: 10px;
}
.spanColors {
  font-weight: bold;
  color: #409eff;
  border: none;
  border-bottom: #409eff solid 3px;
}
</style>
<style>
.el-table th.el-table__cell>.cell {
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/zzc/prices.vue